export interface ProfileInfo {
  name: string;
  nameEn: string;
  nameJp: string;
  avatar: string;
  heroImage: string;
  tagline: string;
  intro: string[];
  basicInfo: { label: string; value: string }[];
  representativeWorkIds: string[];
  honors: { year: string; title: string }[];
  skills: string[];
}

export const profile: ProfileInfo = {
  name: '深田咏美',
  nameEn: 'Eimi Fukada',
  nameJp: '深田えいみ',
  avatar:
    'https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20of%20a%20poised%20woman%20in%20a%20refined%20dark%20outfit%20against%20a%20soft%20grey%20studio%20background%2C%20muted%20tones%20with%20deep%20red%20accent%2C%20cinematic%20soft%20lighting%2C%20high%20detail&width=800&height=1000&seq=ework-profile&orientation=portrait',
  heroImage:
    'https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20scene%20of%20a%20dimly%20lit%20film%20studio%20with%20warm%20spotlight%20and%20deep%20red%20accents%2C%20muted%20grey%20tones%2C%20moody%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=ework-profile-hero&orientation=landscape',
  tagline: '演员 · 影像创作者 · 公益影像计划发起人',
  intro: [
    '深田咏美，日本女演员。她以细腻而克制的表演风格被观众熟知，作品横跨电影、电视剧与纪录片，善于塑造那些「安静却有力」的女性角色。',
    '在长期的职业积累中，她逐渐形成了自己对表演的理解：比起角色的功能，她更在意角色有没有真正「活过」。为此，她习惯在开拍前为每一个角色撰写背景小传，哪怕这些内容最终不会出现在成片里。',
    '近年，她开始尝试纪录片与幕后创作，关注普通人的生活故事，并发起公益影像计划，鼓励更多人用镜头记录身边被忽略的日常。',
  ],
  basicInfo: [
    { label: '艺名', value: '深田咏美（Eimi Fukada）' },
    { label: '国籍', value: '日本' },
    { label: '职业', value: '演员、影像创作者' },
    { label: '出生日期', value: '1998 年 3 月 14 日' },
    { label: '出生地', value: '日本 神奈川县' },
    { label: '身高', value: '163 cm' },
    { label: '出道年份', value: '2017 年' },
    { label: '代表类型', value: '剧情、文艺、都市、纪录片' },
    { label: '活跃地区', value: '日本 及 亚洲多个地区' },
    { label: '语言', value: '日语、英语、中文（学习中）' },
  ],
  representativeWorkIds: ['w001', 'w002', 'w003', 'w007', 'w009', 'w010'],
  honors: [
    { year: '2026', title: '东京国际电影节 特邀嘉宾' },
    { year: '2025', title: '年度都市剧 最佳女主角（提名）' },
    { year: '2024', title: '纪录片单元 评审推荐' },
    { year: '2023', title: '年度人气演员 年度十强' },
    { year: '2021', title: '文艺电影季 最具突破表演' },
  ],
  skills: ['角色塑造', '长篇独白', '舞台表现', '纪录片讲述', '影像策划'],
};